export default "__VITE_ASSET__Ea40H9JQ__"